// lodash
import find from 'lodash/find';

import appConstants from '../../constants/appConstants';

function getDeliveryInstructions(formValues, deliveryAccessibilityInstructionsEnabled) {
  let deliveryInstructions;
  let selectedOptionPrefix;

  const deliveryInstruction = formValues.deliveryInstructions;

  if (deliveryAccessibilityInstructionsEnabled) {
    if (!deliveryInstruction) {
      return formValues.deliveryInstructionsOption;
    }

    selectedOptionPrefix = `${formValues.deliveryInstructionsOption}:`;
  } else {
    deliveryInstructions = appConstants.DELIVERY_INSTRUCTIONS;
    selectedOptionPrefix = (find(deliveryInstructions, {
      label: formValues.deliveryInstructionsOption,
    }) || {}).prefix;
  }

  return `${selectedOptionPrefix} ${deliveryInstruction}`;
}

export default getDeliveryInstructions;
